export const FILE_FOLDERS = {
    WASTE_COLLECTION_FORM_PHOTOS: "WASTE_COLLECTION_FORM_PHOTOS", //ok
    PARENT_SIGNATURES: "PARENT_SIGNATURES", //ok
    LESSON_ANSWER_PHOTOS: "LESSON_ANSWER_PHOTOS", //ok
    LESSON_IMAGES: "LESSON_IMAGES", //ok
    SLIDE_IMAGES: "SLIDE_IMAGES", //ok
    OPTION_IMAGES: "OPTION_IMAGES", //ok
    USER_PROTOCOLS: "USER_PROTOCOLS", //Ok
    LESSON_PDFS: "LESSON_PDFS", //ok
    DEFAULT: "DEFAULT", //OK
} as const;

export type FileFolder = typeof FILE_FOLDERS[keyof typeof FILE_FOLDERS];
